/**
 * Navigation Menu functionality
 */

export function initMenu() {
    const menuToggle = document.getElementById('menuToggle');
    const headerMenu = document.querySelector('.header__menu');
    const returnHome = document.querySelector('.header__menu .row');
    const menuItems = document.querySelectorAll('.menu-primary li a');

    // Toggle menu (open/close)
    if (menuToggle && headerMenu) {
        menuToggle.addEventListener('click', function () {
            const isActive = headerMenu.classList.contains('menu--active');

            if (isActive) {
                // Close menu
                headerMenu.classList.remove('menu--active');
                document.body.classList.remove('menu-open');
            } else {
                // Open menu
                headerMenu.classList.add('menu--active');
                document.body.classList.add('menu-open');
            }
        });
    }

    // Close menu with return home link
    if (returnHome && headerMenu) {
        returnHome.addEventListener('click', function (e) {
            e.preventDefault();
            headerMenu.classList.remove('menu--active');
            document.body.classList.remove('menu-open');
            // Navigate to home if not already there
            const link = this.querySelector('a');
            if (link && link.getAttribute('href') === '/' && window.location.pathname !== '/') {
                window.location.href = '/';
            }
        });
    }

    // Close menu with Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && headerMenu && headerMenu.classList.contains('menu--active')) {
            headerMenu.classList.remove('menu--active');
            document.body.classList.remove('menu-open');
        }
    });

    // Close menu when clicking on main content
    const mainElement = document.querySelector('main');
    if (mainElement && headerMenu) {
        mainElement.addEventListener('click', function () {
            if (headerMenu.classList.contains('menu--active')) {
                headerMenu.classList.remove('menu--active');
                document.body.classList.remove('menu-open');
            }
        });
    }

    // Optional: Close menu when clicking menu items (for single page navigation)
    menuItems.forEach(item => {
        item.addEventListener('click', function () {
            // Only close if it's an anchor link (starts with #)
            const href = this.getAttribute('href');
            if (href && href.startsWith('#')) {
                headerMenu.classList.remove('menu--active');
                document.body.classList.remove('menu-open');
            }
        });
    });
}